import { atom } from "recoil";

export const supplierCurrencies = atom({
  key: "supplierCurrencies",
  default: [],
});
